import React from 'react';
import styled from 'styled-components';
import Button from '../../Button';
import Icon from '../../Icon';
import { I18n } from 'react-redux-i18n';

const PopinContainer = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(173, 181, 189, 0.1);
  background-color: white;
  position: relative;

  .closeContainer {
    position: absolute;
    font-size: 12px;
    color: black;
    border-radius: 50%;
    top: 5px;
    right: 5px;
    width: 16px;
    height: 16px;
    min-height: 16px;
    min-width: 16px;
    background-color: rgba(31, 43, 55, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .closeContainer:hover {
    cursor: pointer;
  }

  .rightContainer {
    width: calc(100% - 470px);
    height: 150px;
  }

  .header {
    display: flex;
    flex-direction: row;
    padding-left: 30px;
    padding-right: 30px;
  }

  .titleContainer {
    display: flex;
    flex-direction: column;
    color: #2b3d54;
  }

  .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 20px;
    margin-left: 30px;
    text-transform: uppercase;
  }

  .date {
    opacity: 0.3;
    margin-top: 6px;
    font-size: 14px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .rightButton {
    margin-left: auto;
    opacity: 0.4;
    width: 210px;
    height: 45px;
  }

  .infoContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 11px;
    margin-top: 16px;
    padding-left: 30px;
    padding-right: 30px;
  }

  .info {
    border-radius: 4px;
    height: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: rgba(245, 245, 245, 0.3);
    padding: 15px 30px;
    color: #2b3d54;
  }

  .infoName {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
  }

  .infoValueContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .dataContainer {
    width: 470px;
    height: 100%;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.dark};
    color: white;
    display: flex;
  }

  .contentDataContainer {
    margin-top: auto;
    margin-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    width: 100%;
    flex-direction: row;
  }

  .dataLogo {
    margin-left: auto;
    margin-top: auto;
    border-radius: 12px;
    max-height: 120px;
    max-width: 180px;
  }

  .dataLogoContainer {
    margin-top: auto;
    margin-left: auto;
  }

  .dataTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    text-transform: uppercase;
    font-size: 20px;
    margin-top: 4px;
    margin-bottom: 30px;
  }

  .dataAddress {
    white-space: normal;
    width: 160px;
    font-size: 16px;
    line-height: 20px;
    color: white;
    vertical-align: center;
    margin-top: 6px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .dataContact {
    margin-top: 9px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .dataIconContainer {
    background-color: rgb(117, 128, 140);
    min-width: 20px;
    min-height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 10px;
  }

  .dataContactValue {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    margin-left: 7px;
    color: white !important;
  }

  .dataEmail {
    max-width: 250px;
    word-break: break-all;
    white-space: normal;
  }

  a {
    text-decoration: none;
    color: unset;
  }
  .dataCountry {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 16px;
    color: white;
    margin-bottom: 5px;
  }
`;

const renderStatInfos = (props) => {
  return (
    <div className="infoContainer">
      <div className="info">
        <p className="infoName">{I18n.t('primeur.direct.popin.nbWine')}</p>
        <div className="infoValueContainer">
          <p>
            {props.store_dn} {I18n.t('primeur.direct.popin.nbWineUnity')}
          </p>
        </div>
      </div>
      <div className="info">
        <p className="infoName">
          {I18n.t('primeur.direct.popin.price')} - {props.wine_name}
        </p>
        <div className="infoValueContainer">
          <p>
            {props.value.toLocaleString('fr-FR', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}{' '}
            {I18n.t('ht')}
          </p>
        </div>
      </div>
      <div className="info">
        <p className="infoName">{I18n.t('primeur.direct.popin.pmmAll')}</p>
        <div className="infoValueContainer">
          <p>
            {props.store_avg_dev && props.store_avg_dev > 0 && '+'}
            {props.store_avg_dev
              ? (props.store_avg_dev * 100).toLocaleString('fr-FR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                })
              : 0}{' '}
            %
          </p>
        </div>
      </div>
      <div className="info">
        <p className="infoName">
          {I18n.t('primeur.direct.popin.pmmWine')} - {props.wine_name}{' '}
        </p>
        <div className="infoValueContainer">
          <p>{props.pmm_diff ? Number(props.pmm_diff * 100).toFixed(2) : 0}%</p>
        </div>
      </div>
    </div>
  );
};

const renderStoreInfo = (props) => (
  <div className="dataContainer">
    <div className="contentDataContainer">
      <div>
        <p className="dataCountry">{props.market}</p>
        <p className="dataTitle">{props.store_name}</p>
        <div className="dataContact">
          <div className="dataIconContainer">
            <Icon icon="phone" />
          </div>
          <p className="dataContactValue">{props.store_phone}</p>
        </div>
        <div className="dataContact">
          <div className="dataIconContainer">
            <Icon icon="world" />
          </div>

          <a target="_blank" href={props.store_address} rel="noreferrer">
            <p className="dataContactValue">
              {props.store_address.length > 30
                ? props.store_address.substring(0, 30) + '...'
                : props.store_address}
            </p>
          </a>
        </div>
        <div className="dataContact">
          <div className="dataIconContainer">
            <p>@</p>
          </div>
          <p className="dataContactValue dataEmail">{props.store_email}</p>
        </div>
      </div>
      <div className="dataLogoContainer">
        {' '}
        {props.store_logo && (
          <img src={props.store_logo} className="dataLogo" />
        )}
      </div>
    </div>
  </div>
);

const renderHeader = (props) => (
  <div className="header">
    <div className="titleContainer">
      <h3 className="title">{I18n.t('primeur.direct.popin.title')}</h3>
    </div>
    <div className="rightButton">
      <a
        target="_blank"
        href={
          props.store_primeur_address
            ? props.store_primeur_address
            : props.store_address
        }
        rel="noreferrer"
      >
        <Button
          label={I18n.t('primeur.direct.popin.accessOffer')}
          color="white"
          width={210}
          textColor="black !important"
          border="0.8px black solid"
          fontFamily="SFCompactText"
          textTransform="normal"
        />
      </a>
    </div>
  </div>
);

const Popin = (props) => {
  return (
    <PopinContainer>
      <div className="closeContainer" onClick={() => props.onClose()}>
        <Icon icon="close" />
      </div>
      {renderStoreInfo(props)}
      <div className="rightContainer">
        {renderHeader(props)}

        {renderStatInfos(props)}
      </div>
    </PopinContainer>
  );
};

export default Popin;
